import { Component, OnInit, Inject, ChangeDetectorRef } from "@angular/core";
import { FormGroup, FormBuilder, Validators, FormControl } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { GeneradoresComponent } from "../generadores.component";
import { map, startWith } from "rxjs/operators";
import { Observable } from "rxjs";
// Services
import { GeneratorService } from "src/app/core/services/actors/generator.service";
import { CountryService } from "src/app/core/services/parameters/country.service";
//Alert
import { AlertNoticeService } from "src/app/core/alert/alert.service";

@Component({
  selector: "edit-modal",
  templateUrl: "./edit-modal.component.html",
})
export class EditarGeneradorModal implements OnInit {
  editGeneratorForm: FormGroup;
  loading = false;
  showAlert = false;
  public date = new Date();
  public mask = ["(", "+", /[1-9]/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/];

  countries = [];
  cities = [];

  types = [
    { id: 1, name: "Mercancía normales" },
    { id: 2, name: "Mercancía especiales" },
    { id: 3, name: "Mercancía preferentes" },
  ];

  public docTypes = [
    {
      id: 1,
      name: "Cédula",
    },
    {
      id: 2,
      name: "Nit",
    },
    {
      id: 3,
      name: "Cédula Extranjería",
    },
    {
      id: 4,
      name: "Otro",
    },
  ];

  filteredCountries: Observable<String[]>;
  filteredCities: Observable<String[]>;

  constructor(public dialogRef: MatDialogRef<GeneradoresComponent>, @Inject(MAT_DIALOG_DATA) public data, private fb: FormBuilder, public alert: AlertNoticeService, private cdr: ChangeDetectorRef, private countryService: CountryService, private generatorService: GeneratorService) {}

  ngOnInit(): void {
    this.editGeneratorForm = this.fb.group({
      businessName: [, Validators.required],
      documentType: [, Validators.required],
      nit: [, Validators.required],
      email: [, Validators.compose([Validators.required, Validators.email])],
      phone: [, Validators.required],
      contact: [, Validators.required],
      country: [, Validators.required],
      city: [, Validators.required],
      type: [,],
    });
    this.generatorService.getGeneratorById(this.data.id).subscribe((_res) => {
      this.date = _res.createdAt;
      this.editGeneratorForm.patchValue({
        businessName: _res.name,
        documentType: _res.documentType || 2,
        nit: _res.nit,
        email: _res.email,
        phone: _res.phone,
        contact: _res.contactName,
        country: _res.countryEntity,
        city: _res.cityEntity,
        type: _res.type,
      });
      this.countryService.getAllCitiesByCountryId(_res.cityEntity?.countryId).subscribe((_res) => {
        this.cities = _res;
        const cityControl = this.editGeneratorForm.controls.city as FormControl;
        this.filteredCities = cityControl.valueChanges.pipe(
          startWith(""),
          map((value) => (typeof value === "string" ? value : value.name)),
          map((name) => {
            if (name) {
              const filterValue = name.toLowerCase();
              return this.cities.filter((option) => option.name.toLowerCase().indexOf(filterValue) === 0);
            } else {
              return this.cities.slice();
            }
          })
        );
      });
    });
    this.countryService.getAllCountries().subscribe((_res) => {
      this.countries = _res;
      const countryControl = this.editGeneratorForm.controls.country as FormControl;
      this.filteredCountries = countryControl.valueChanges.pipe(
        startWith(""),
        map((value) => (typeof value === "string" ? value : value.name)),
        map((name) => {
          if (name) {
            const filterValue = name.toLowerCase();
            return this.countries.filter((option) => option.name.toLowerCase().indexOf(filterValue) === 0);
          } else {
            return this.countries.slice();
          }
        })
      );
    });
  }

  displayFn(user): string {
    return user && user.name ? user.name : "";
  }

  getCities(id) {
    this.editGeneratorForm.patchValue({
      city: null,
    });
    this.countryService.getAllCitiesByCountryId(id).subscribe((_res) => {
      this.cities = _res;
      const cityControl = this.editGeneratorForm.controls.city as FormControl;
      this.filteredCities = cityControl.valueChanges.pipe(
        startWith(""),
        map((value) => (typeof value === "string" ? value : value.name)),
        map((name) => {
          if (name) {
            const filterValue = name.toLowerCase();
            return this.cities.filter((option) => option.name.toLowerCase().indexOf(filterValue) === 0);
          } else {
            return this.cities.slice();
          }
        })
      );
    });
  }

  onNoClick(refresh): void {
    this.dialogRef.close(refresh);
  }

  get f() {
    return this.editGeneratorForm.controls;
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.editGeneratorForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  phoneToNumber(value) {
    const newValue = value.split(/[ +()-]+/);
    return newValue.join("");
  }

  submit(form) {
    this.loading = true;
    this.showAlert = false;
    if (form.valid) {
      const data = {
        name: form.value.businessName,
        documentType: form.value.documentType,
        contactName: form.value.contact,
        phone: this.phoneToNumber(form.value.phone),
        email: form.value.email,
        nit: form.value.nit.toString(),
        countryId: form.value.country?.id,
        cityId: form.value.city?.id,
        type: form.value.type,
      };
      this.generatorService.editGenerator(data, this.data.id).subscribe(
        (_res) => {
          this.alert.setNotice("Generador editado correctamente", "success");
          this.showAlert = true;
          this.loading = false;
          setTimeout(() => this.onNoClick(true), 1000);
          this.cdr.markForCheck();
        },
        (_err) => {
          this.loading = false;
          if (_err.error.errors) {
            this.alert.setNotice(_err.error.errors[0].defaultMessage, "danger");
          } else {
            this.alert.setNotice(_err.error.message, "danger");
          }
          this.showAlert = true;
          this.cdr.markForCheck();
        }
      );
    } else {
      this.loading = false;
      Object.keys(form.ontrols).forEach((controlName) => form.controls[controlName].markAsTouched());
    }
  }
}
